import { useState } from 'react';
import { jobTrendRankingSelector } from '@doda/common/src/redux/features/JobContent/JobTrend/jobTrendRanking';
import { createInitialValueForBargraph } from '@doda/common/src/logics/JobContent/JobTrend/createInitialValueForBargraph';
import { useAppSelector } from '../../../redux/hooks';

/**
 * 各カテゴリごとの棒グラフState管理hooks
 * @returns 選択された値とセッター
 */
export const useBargraphSelected = () => {
  const rankingList = useAppSelector(jobTrendRankingSelector);
  const {
    initialRequire,
    initialIncome,
    initialWorkplace,
    initialHoliday,
    initialEmployeeAverageAge,
    initialEmploymentStatus,
    initialWelfareBenefit,
    initialPositions,
    initialLanguage,
    initialEstablish,
  } = createInitialValueForBargraph(rankingList);

  // 募集・採用情報クリックState
  const [requirementsSelected, setRequirementsSelected] =
    useState(initialRequire);

  // 年収クリックState
  const [incomeSelected, setIncomeSelected] = useState(initialIncome);

  // 会社・職場の環境クリックState
  const [workplaceEnvironmentSelected, setWorkplaceEnvironmentSelected] =
    useState(initialWorkplace);

  // 休日・働き方クリックState
  const [holidayAndWayOfWorkingSelected, setHolidayAndWayOfWorkingSelected] =
    useState(initialHoliday);

  // 平均年齢クリックState
  const [employeeAverageAgeSelected, setEmployeeAverageAgeSelected] = useState(
    initialEmployeeAverageAge
  );

  // 雇用形態クリックState
  const [employmentStatusSelected, setEmploymentStatusSelected] = useState(
    initialEmploymentStatus
  );

  // 福利厚生クリックState
  const [welfareBenefitsSelected, setWelfareBenefitsSelected] = useState(
    initialWelfareBenefit
  );

  // 仕事内容クリックState
  const [positionsSelected, setPositionsSelected] = useState(initialPositions);

  // 語学クリックState
  const [languageSkillsSelected, setLanguageSkillsSelected] =
    useState(initialLanguage);

  // 設立クリックState
  const [establishSelected, setEstablishSelected] = useState(initialEstablish);

  return {
    requirementsSelected,
    incomeSelected,
    workplaceEnvironmentSelected,
    holidayAndWayOfWorkingSelected,
    employeeAverageAgeSelected,
    employmentStatusSelected,
    welfareBenefitsSelected,
    positionsSelected,
    languageSkillsSelected,
    establishSelected,
    setRequirementsSelected,
    setIncomeSelected,
    setWorkplaceEnvironmentSelected,
    setHolidayAndWayOfWorkingSelected,
    setEmployeeAverageAgeSelected,
    setEmploymentStatusSelected,
    setWelfareBenefitsSelected,
    setPositionsSelected,
    setLanguageSkillsSelected,
    setEstablishSelected,
  };
};
